import { carkeyPresentService } from '../../helpers/services/carkeyPresent.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRESENT_MODULE = 'carkeyPresent'; 

// define action 
export const GET_ALL_CAR_KEY_PRESENTS = 'getAllcarkeyPresents';
export const GET_CAR_KEY_PRESENT = 'getcarkeyPresent';
export const UPDATE_CAR_KEY_PRESENT = 'updatecarkeyPresent';
export const CREATE_CAR_KEY_PRESENT = 'createcarkeyPresent';
export const UPDATE_CAR_KEY_PRESENT_STATUS = 'updatecarkeyPresentStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_CAR_KEY_PRESENTS_REQUEST = "getAllcarkeyPresents";
const GET_CAR_KEY_PRESENT_REQUEST = "getcarkeyPresent";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CAR_KEY_PRESENTS]({ commit }, { filter }) {
        carkeyPresentService
            .getAllcarkeyPresents(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CAR_KEY_PRESENTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_CAR_KEY_PRESENT]({ commit }, { id }) {
        carkeyPresentService
            .getcarkeyPresent(id)
            .then(
                (result) => {
                    commit(GET_CAR_KEY_PRESENT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CAR_KEY_PRESENT]({ commit }, { data }) {
        commit(REQUEST)
        carkeyPresentService
            .updatecarkeyPresent(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.carkeyPresent')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_CAR_KEY_PRESENT]({ commit }, { data }) {
        commit(REQUEST)
        carkeyPresentService
            .createcarkeyPresent(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.carkeyPresent')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CAR_KEY_PRESENT_STATUS]({ dispatch }, { filter, data }) {
        carkeyPresentService
            .updatecarkeyPresentStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_CAR_KEY_PRESENTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Car-key-present-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_CAR_KEY_PRESENTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_CAR_KEY_PRESENT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


